// @flow
import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import * as allActionCreators from './actions/allActionCreators';
import { Alert } from 'react-bootstrap';
import Header from './components/Header';
import UpdatedTCModalContainer from './containers/UpdatedTCModalContainer';
import Login from './containers/Login';
import type { Dispatch } from 'redux';

type Props = {
  authentication: Object,
  children: React$Element<*>,
  currentOrganisation: Object,
  currentLocation: Object,
  params: Object,
  routes: Object,
  logout: () => void,
  decodeToken: (t: string) => Promise<*>,
  clearAccessError: any,
  router: any
};

class App extends React.Component<Props> {
  componentWillMount() {
    const loginValid = this.checkLoginValid();

    if (!loginValid) {
      this.props.logout();
    }
  }

  getCurrentComponent = () => {
    if (this.props.authentication.isLoggedIn) {
      return this.props.children;
    } else {
      return <Login {...this.props} />;
    }
  };

  checkLoginValid = () => {
    const { token, isLoggedIn } = this.props.authentication;

    if (isLoggedIn) {
      return this.props
        .decodeToken(token)
        .then(
          () => this.props.authentication.tokenContent.expires > Date.now()
        );
    }
    return false;
  };

  render() {
    const currentComponent = this.getCurrentComponent();
    const { authentication } = this.props;
    const currentRoutes = this.props.routes;
    const currentRoute = currentRoutes[currentRoutes.length - 1];
    const routeName = currentRoute.name || 'Campaign Targeter';
    const routeContext = currentRoute.context;
    const authenticationError = this.props.authentication.error;

    return (
      <div className="App" aria-live="polite">
        <Helmet>
          <meta charSet="utf-8" />
          <title>Campaign Targeter</title>
        </Helmet>
        <Header
          currentOrganisation={this.props.currentOrganisation}
          currentLocation={this.props.currentLocation}
          authentication={this.props.authentication}
          routeName={routeName}
          params={this.props.params}
          routeContext={routeContext}
          router={this.props.router}
        />
        {authenticationError && (
          <Alert bsStyle="danger" onDismiss={this.props.clearAccessError}>
            {authenticationError}
          </Alert>
        )}
        {authentication.isLoggedIn && authentication.user && (
          <UpdatedTCModalContainer
            needToSignTC={
              typeof authentication.user.needToSignTC === 'boolean'
                ? authentication.user.needToSignTC
                : false
            }
            loggedInUser={authentication.user}
          />
        )}
        {currentComponent}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    authentication: state.authentication,
    organisations: state.organisations,
    locations: state.locations,
    campaigns: state.campaigns,
    insightSets: state.insightSets,
    shapeSets: state.shapeSets,
    industries: state.industries,
    agencies: state.agencies,
    currentOrganisation: state.currentOrganisation,
    currentLocation: state.currentLocation,
    currentInsightSet: state.currentInsightSet,
    currentShapeSet: state.currentShapeSet,
    currentIndustry: state.currentIndustry,
    currentCampaign: state.currentCampaign
  };
}

function mapDispatchToProps(dispatch: Dispatch<*>) {
  return bindActionCreators({ ...allActionCreators }, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/App.js